import { Container } from "@/components/Container/Container";
import { Section } from "@/components/Section/Section";
import { Reveal } from "@/components/Reveal/Reveal";
import { thesis } from "@/spiel/thesis";
import styles from "./Thesis.module.scss";

export const Thesis = () => (
  <Section id="thesis" deep>
    <Container narrow>
      <Reveal>
        <div className={styles.body}>
          <p className={styles.oneLiner}>{thesis.oneLiner}</p>
          {thesis.paragraphs.map((paragraph) => (
            <p key={paragraph.slice(0, 24)} className={styles.paragraph}>
              {paragraph}
            </p>
          ))}
        </div>
      </Reveal>
    </Container>
  </Section>
);
